import React from 'react';
import AuthProcessing from './AuthProcessing';
import LoadingIcon from './LoadingIcon';
import { Helmet } from 'react-helmet';

export default function AuthLandingPage() {
  return (
    <>
      <Helmet>
        <title>Loading...{process.env.REACT_APP_PAGETITLE_TEXT}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <LoadingIcon loadingText="Your Account is Loading" />
      <AuthProcessing />
    </>
  );
}
